/**
 * Main entry point for client-side application
 * @module client/index
 */

// eslint-disable-next-line import/no-import-module-exports
import ComponentHelper from './components/00_utilities/helpers/ComponentHelper';

const componentHelper = new ComponentHelper();

/* global __webpack_public_path__ */
if (__devMode__) {
    // eslint-disable-next-line camelcase
    __webpack_public_path__ = `${process.env.WP_HOME}:44446/${__assetsBasePath__}`;
}

// Initialize components on page load
componentHelper.initializePage();

/**
 * Removes loading state from body after page load
 * @function removeAfterReload
 */
function removeAfterReload() {
    document.querySelector('body').classList.remove('body-remove-on-load');
}

// Make jQuery available globally
window.$ = jQuery;

/**
 * Add event listener for page load to handle animations and transitions
 */
window.addEventListener('load', () => {
    setTimeout(removeAfterReload, 1000);
});

/**
 * Check for hot module replacement and use it if possible
 * Enables seamless development experience with webpack
 */
if (module.hot) {
    module.hot.accept();
}
